/** Format an epoch-ms timestamp using the active UI locale. */
export function timeAgo(ms: number, locale: string, now = Date.now()): string {
  const elapsed = Math.max(0, now - ms);
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto", style: "narrow" });
  const minutes = Math.floor(elapsed / 60_000);
  if (minutes < 1) return rtf.format(0, "second");
  if (minutes < 60) return rtf.format(-minutes, "minute");
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return rtf.format(-hours, "hour");
  const days = Math.floor(hours / 24);
  if (days < 30) return rtf.format(-days, "day");
  return new Date(ms).toLocaleDateString(locale);
}

/** Epoch-ms → YYYY-MM-DD (locale-stable). Returns "—" for null. */
export function formatDate(ms: number | null | undefined): string {
  if (!ms) return "—";
  return new Date(ms).toLocaleDateString("en-CA");
}

/**
 * Ngày GIỜ đầy đủ, cho vết kiểm toán.
 *
 * `timeAgo` đọc nhanh nhưng "3 ngày trước" không đối chiếu được với bất cứ thứ
 * gì. Chỗ nào là dấu vết kiểm toán thì phải có mốc tuyệt đối — dùng làm tooltip
 * để vừa nhanh vừa chính xác.
 */
export function formatDateTime(ms: number | null | undefined, locale = "en-GB"): string {
  if (ms == null) return "—";
  return new Date(ms).toLocaleString(locale, {
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
  });
}
